import { KnownCreateHubDtoType, ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { RJSFSchema } from '@rjsf/utils';
import { HubSettingsFormOutput } from './form-output';

const hubTypeDisplayNames: Record<KnownCreateHubDtoType, string> = {
  [KnownCreateHubDtoType.LockersHub]: 'Lockers',
  [KnownCreateHubDtoType.SpacesHub]: 'Parcel Room / Collect & Go',
  [KnownCreateHubDtoType.KiosklessSpacesHub]: 'Concierge / Counter Collect',
  [KnownCreateHubDtoType.LockersHubExternal]: 'Lockerpoint / Other Via Gateway'
};

export class HubSettingsFormSchema {
  static FromFormData(formOutput: HubSettingsFormOutput, projectOptions: ProjectDto[], isEdit = false): RJSFSchema {
    const isExternalHub = formOutput.type === KnownCreateHubDtoType.LockersHubExternal;

    return {
      properties: {
        name: {
          type: 'string',
          title: 'Hub name'
        },
        type: {
          type: 'string',
          title: 'Type',
          default: '',
          readOnly: isEdit,
          oneOf: Object.values(KnownCreateHubDtoType).map((type) => ({
            type: 'string' as const,
            title: hubTypeDisplayNames[type],
            enum: [type]
          }))
        },
        managedBy: {
          type: 'string',
          title: 'Managed by',
          readOnly: isEdit,
          ...(projectOptions.length > 0 && {
            oneOf: projectOptions.map((p) => ({
              type: 'string' as const,
              title: p.name,
              enum: [p.id]
            }))
          })
        },
        // TODO GFC-7040: Add IoT Hub ID field once we implement the layout update
        // The IoT Hub ID lives on the Kiosk (not the Hub) and requires a separate setup endpoint.
        ...(isExternalHub && {
          externalID: {
            type: 'string',
            title: 'Gateway Location ID'
          },
          externalShortID: {
            type: 'string',
            title: 'External short ID'
          },
          displayAddress: {
            type: 'string',
            title: 'Display address'
          },
          openingHoursDisplay: {
            type: 'string',
            title: 'Opening hours'
          }
        }),
        location: {
          type: 'object',
          title: '',
          properties: {
            latitude: {
              type: 'number',
              title: 'Latitude'
            },
            longitude: {
              type: 'number',
              title: 'Longitude'
            }
          },
          required: ['latitude', 'longitude']
        },
        directions: {
          type: 'string',
          title: 'Directions'
        },
        additionalDirections: {
          type: 'string',
          title: 'Additional directions once in building'
        },
        identificationNote: {
          type: 'string',
          title: 'Identification note'
        }
      },
      required: ['name', 'type', 'managedBy', ...(isExternalHub ? ['externalID'] : []), 'location', 'directions']
    };
  }
}
